import { useaxios } from "../../../../utils/useaxios";
export default (project_expense_name, project_expense_amount, project_expense_type, project_expense_date, project_expense_note) => setloading => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    setloading(true);
    useaxios('project_expense/create.php', { project_expense_name, project_expense_amount, project_expense_type, project_expense_date, project_expense_note }).then((res) => {
        console.log(res);
        if (res.status == "ok") {
        } else {
            // clear();
        }
        setloading(false);
    });
}